interface Props{
    clickedOnGenerateCupon:React.MouseEventHandler<HTMLButtonElement> | undefined;
    clickedOnRedeemCupon:React.MouseEventHandler<HTMLButtonElement> | undefined;
    clickedOnViewCupon:React.MouseEventHandler<HTMLButtonElement> | undefined;
}
const CouponHeader: React.FC<Props> = ({clickedOnGenerateCupon,clickedOnViewCupon, clickedOnRedeemCupon}) => {
  return (
    <>
      <div className="m-4">
        <div className="bg-gradient-to-br from-primary-400 to-primary-600 text-white text-center py-6 px-20 rounded-lg shadow-md shadow-primary-300 relative">
          <h3 className="text-3xl font-semibold mb-4">
            Generate Coupons to give free subscription
            <br />
            <span className="text-base">
              Choose a coupon generation type: <strong>Admin — Limited</strong> or <strong>Printed — Unlimited</strong>.
            </span>
          </h3>
          <div className="flex items-center space-x-2 mb-4">
            <button
            onClick={clickedOnGenerateCupon}
              id="cpnCode"
              className="border border-dashed border-white text-white px-4 py-2 rounded-l transition duration-200 
            hover:bg-white  hover:text-primary-700 hover:border-primary-700"
            >
              Generate Coupon
            </button>
            <button
            onClick={clickedOnViewCupon}
              id="cpnBtn"
              className="border border-dashed border-white text-white px-4 py-2  transition duration-200 
            hover:bg-white hover:text-primary-700 hover:border-primary-700"
            >
              View Coupons
            </button>
            <button
            onClick={clickedOnRedeemCupon}
              id="cpnRedeem"
              className="border border-dashed border-white text-white px-4 py-2 rounded-r transition duration-200 
            hover:bg-white hover:text-primary-700 hover:border-primary-700"
            >
              Redeem Coupon
            </button>
          </div>
          <p className="text-sm">Valid Till: 31Dec, 2025</p>
          <div className="w-12 h-12 bg-white rounded-full absolute top-1/2 transform -translate-y-1/2 left-0 -ml-6"></div>
          <div className="w-12 h-12 bg-white rounded-full absolute top-1/2 transform -translate-y-1/2 right-0 -mr-6"></div>
        </div>
      </div>
    </>
  );
};
export default CouponHeader;
